import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { Card, CardContent, Typography, Button, TextField } from '@mui/material';

export default function TicketOptions({  eventId, eventData, onClose, onAddToCart }) {
        
  const [ticketTypes, setTicketTypes] = useState([]);

  useEffect(() => {
    const fetchTickets = async () => {
      const ticketsCol = collection(db, 'events', eventId, 'tickets');
      const snapshot = await getDocs(ticketsCol);
      const tickets = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setTicketTypes(tickets);
    };

    fetchTickets();
  }, [eventId]);

  const [quantities, setQuantities] = useState({});

  const handleChange = (id, value) => {
    setQuantities({ ...quantities, [id]: parseInt(value) || 0 });
  };

  const addOrUpdateCartItem = async (userId, ticketItem) => {
    const cartRef = doc(db, 'users', userId, 'ticketCart', ticketItem.ticketType); // ticketType as doc ID
    await setDoc(cartRef, {
      ...ticketItem,
      addedAt: new Date()
    });
  };

  return (
    <>
      <Typography variant="h5" gutterBottom>Select Your Tickets for {eventId}</Typography>
      {ticketTypes.map(ticket => (
        <Card key={ticket.id} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6">{ticket.ticketType}</Typography>
            <Typography>{ticket.description}</Typography>
            <Typography>Price: ${ticket.price}</Typography>
            <TextField
              type="number"
              label="Quantity"
              value={quantities[ticket.id] || 0}
              onChange={e => handleChange(ticket.id, e.target.value)}
              inputProps={{ min: 0 }}
              sx={{ mt: 1, mb: 1 }}
            />
            <Button
              variant="contained"
              onClick={() => onAddToCart(ticket, quantities[ticket.id] || 0)}
              disabled={!quantities[ticket.id]}
            >
              Add to Cart
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
}
